import 'react-app-polyfill/ie11';
import React, { useState } from 'react';
//import { useParams } from 'react-router-dom';
import { AppTableNoData } from 'components/common/AppTableUtils';
import AppPagination from "components/common/AppPagination";

const FlightErrors = (props) => {
    const data = props.data;
    //const [data, setData] = useState(props.data);
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });

    return (<>
   <div className="row p-3 align-items-center" >
   
   <div>
   <table className="table table-hover table-sm table-bordered">
                        <thead style={{ zIndex: 5 }}>
                            <tr>
                            <th scope="col">Error code</th>
                            <th scope="col">Error field name</th>
                            <th scope="col">Error field value</th>
                            
                                </tr>
                                </thead>
                                <tbody>
                                {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                                return (
                                  
                                <tr key={i} className="hand">
                                    <td style={{ textAlign: 'center' }}>{item.errorCode}</td>
                                    <td style={{ textAlign: 'center' }}>{item.errorFieldName}</td>
                                    <td style={{ textAlign: 'center' }}>  {item.errorFieldValue}</td>
                                    
                                </tr>
                                   )
                                })
                                }
                                </tbody>
                                </table>
                                {!data.length ? <AppTableNoData /> :
                            <AppPagination
                                pageSize={paginationObject.pageSize}
                                totalRecords={data.length}
                                currentPage={paginationObject.currPage}
                                endIndex={paginationObject.endIndex}
                                startIndex={paginationObject.startIndex}
                                setPaginationObject={(ele) => {
                                    setPaginationObject((data) => {
                                        return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                    })
                                }}
                            ></AppPagination>
                        }
   </div>
   </div>                 
    </>
    )
}
export default FlightErrors;

